import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/operations/policies')({
  component: () => <PageStub title="Policy Manager" description="Business policies and procedures" />,
});
